import { ArrowLeft, Search } from "lucide-react"
import { useMemo, useState } from "react"

import { getSubmissionList } from "@/features/jobs/manage/api/manage.api"
import { FilterSubmission } from "@/features/jobs/manage/components/manage-filter"
import {
  SubmissionList,
  SubmissionSkeleton
} from "@/features/jobs/manage/components/manage-list-page"
import { useDebounce, useInfinitePageQuery } from "@/modules/helpers/hooks"
import {
  transformFilterSubmissionToQueryParams,
  useFilterSubmission
} from "@/modules/helpers/hooks/shared"
import { sendHaptic } from "@/modules/helpers/utils"

const SubmissionSearchPage = () => {
  const [search, setSearch] = useState("")
  const debouncedSearch = useDebounce(search, 300)
  const { filter } = useFilterSubmission()
  // Transform filter state to API query params
  const apiParams = useMemo(() => {
    const transformed = transformFilterSubmissionToQueryParams(filter)
    return {
      keyword: debouncedSearch || undefined,
      ...transformed
    }
  }, [filter, debouncedSearch])

  const { data, fetchNextPage, hasNextPage, isLoading, isFetchingNextPage, forceRefetch } =
    useInfinitePageQuery({
      queryKey: ["submission-search", debouncedSearch, JSON.stringify(filter)],
      queryFn: ({ page, limit }) =>
        getSubmissionList({
          page,
          take: limit,
          ...apiParams
        }),
      params: apiParams
    })

  const submissions = data?.list || []

  return (
    <div className="flex flex-col h-full bg-white">
      {/* Header Search */}
      <div className="sticky top-0 z-50 flex items-center gap-2 p-4 border-b border-gray-200 bg-white">
        <button
          onClick={() => {
            window.history.back()
            sendHaptic()
          }}
          className="p-2 hover:bg-gray-100 rounded-full bg-primary-50"
        >
          <ArrowLeft className="w-5 h-5 text-primary" />
        </button>
        <div className="flex-1 relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400" />
          <input
            type="text"
            placeholder="Tìm kiếm sản phẩm..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full rounded-xl border border-gray-300 bg-white py-3 pl-10 pr-4 text-sm focus:border-gray-800 focus:outline-none focus:ring-1 focus:ring-gray-800"
            autoFocus
          />
        </div>
        <FilterSubmission />
      </div>

      {/* Content */}
      <div className="flex-1 overflow-y-auto px-2" id="scrollable">
        {isLoading && <SubmissionSkeleton />}

        <SubmissionList
          forceRefetch={forceRefetch}
          data={submissions}
          isLoading={isLoading}
          isFetchingNextPage={isFetchingNextPage}
          hasNextPage={hasNextPage}
          onLoadMore={() => !isFetchingNextPage && hasNextPage && fetchNextPage()}
        />
      </div>
    </div>
  )
}

export default SubmissionSearchPage
